import { ContainerModule, interfaces } from 'inversify';
import * as Api from '../api'
import { DefaultStateSerializerFactory,
         StateSerializationPluginResolverSymbol } from './default-state-serializer-factory';
import { StateSerializationPluginSymbol, StateSerializationPlugin } from '../api';
import { DefaultTypedStateSerializer } from './default-typed-state-serializer';

export const stateSerializationDomainModule = new ContainerModule((bind) => {
  bind<Api.StateSerializationFactory>(
    Api.StateSerializationFactorySymbol).to(DefaultStateSerializerFactory).inSingletonScope();
  bind<Api.TypedStateSerializer>(
    Api.TypedStateSerializerSymbol).to(DefaultTypedStateSerializer);
  bind(StateSerializationPluginResolverSymbol).toFactory((c) => () => {

    let plugins = []
    let container: interfaces.Container | null  = c.container
    while (container) {

      const local = container.getAll<StateSerializationPlugin<unknown>>(StateSerializationPluginSymbol)
      plugins.push(...local)

      container = container.parent
    }

    return plugins
  })
});


